module.exports = __webpack_public_path__ + "static/media/diamond_256x256.16f2e371.png";